(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-page"] && !Shopify.designMode) return;
  try {
    
  const filterButtons = document.querySelectorAll('[data-filter]');
  const cards = document.querySelectorAll('.mm-gal__card');
  const loadMoreBtn = document.getElementById('load-more');
  let visibleCount = 8;

  function filterCards(category) {
    cards.forEach((card, index) => {
      const cardCategory = card.dataset.category || 'all';
      const matches = category === 'all' || cardCategory === category;

      if (matches && index < visibleCount) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
    });
  }

  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      filterButtons.forEach(b => b.classList.remove('mm-chip--active'));
      btn.classList.add('mm-chip--active');
      const category = btn.dataset.filter;
      visibleCount = 8;
      filterCards(category);
      loadMoreBtn.style.display = visibleCount >= cards.length ? 'none' : 'inline-block';
    });
  });

  loadMoreBtn.addEventListener('click', () => {
    visibleCount += 4;
    const activeFilter = document.querySelector('.mm-chip--active').dataset.filter;
    filterCards(activeFilter);
  });

  filterCards('all');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mm-coll__filter-label').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const options = btn.nextElementSibling;
      if (options) {
        options.style.display = options.style.display === 'none' ? 'flex' : 'none';
      }
    });
  });

  // Drawer open/close/scrim handled globally by theme.js via
  // [data-mm-drawer-open] / [data-mm-drawer-close] / [data-mm-drawer-scrim]

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  var toggle = document.getElementById('mm-rev-toggle');
  var panel = document.getElementById('mm-review-form');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var first = panel.querySelector('input[type="text"]');
        if (first) first.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
